// 命名：模块名+功能
export const ACCESS_LOGIN = 'ACCESS_LOGIN' // 授权登录
export const ACCESS_LOGOUT = 'ACCESS_LOGOUT' // 登出

export const CARGO_SETVC = 'CARGO_SETVC'
export const CARGO_SETCC = 'CARGO_SETCC'
export const CARGO_SETPC = 'CARGO_SETPC'
export const CARGO_SETTC = 'CARGO_SETTC'

export const PATH_SETVC = 'PATH_SETVC'



// WEBPACK FOOTER //
// ./src/store/mutations-type.js